module.exports = __webpack_public_path__ + "static/img/qrcode2.ad26788.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/qrcode2.jpg
// module id = 4W72
// module chunks = 19